jQuery(document).ready(function($) {

    function isCartPage() {
        return $('body').hasClass('woocommerce-cart');
    }

    function updateCart(inputName, inputValue) {
        let timeout;

        $('input[name="' + inputName + '"]').each(function(){
            $(this).val(inputValue);
        });
        $( '.woocommerce-cart-form' ).find( ':input[name="update_cart"]' ).prop( 'disabled', false );

        /*if ( timeout !== undefined) {
            clearTimeout( timeout );
        }*/

        setTimeout(function(){
            $("[name='update_cart']").trigger('click');
        }, 500 );
    }

    function addSpinner() {
        $('.woocommerce-cart-form__spinner').addClass('loaded');
    }


    $(document).on("keydown", ".woocommerce-cart-form input.qty", function(event) {
        let name = $(this).attr('name');
        let value = $(this).val();

        if(event.keyCode === 13) {
            addSpinner();

            event.preventDefault();
            updateCart(name, value);

            return false;
        }
    });


    $( document.body ).on('change', '.woocommerce-cart-form input.qty', function(event){
        if (isCartPage) {
            let name = $(this).attr('name');
            let value = parseInt( $(this).val() );
            let max = parseInt( $(this).attr('max') );
            let min = 1;

            addSpinner();

            if ( max >= value && value > 0 ) {
                updateCart(name, value);
            } else if ( value > max) {
                $(this).val(max);

                updateCart(name, max);
            } else if (value < min) {
                $(this).val(min);

                updateCart(name, min);
            }
        }
    });
});